import type { HeavenlyStem } from '../types/stems';
import type { EarthlyBranch } from '../types/branches';
import type { Ohaeng } from '../types/elements';

// 천간 (Heavenly Stems) - 10 stems
export const HEAVENLY_STEMS: readonly HeavenlyStem[] = ['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'] as const;

// 지지 (Earthly Branches) - 12 branches
export const EARTHLY_BRANCHES: readonly EarthlyBranch[] = ['子','丑','寅','卯','辰','巳','午','未','申','酉','戌','亥'] as const;

// 육십갑자 (Sexagenary cycle) - 60 combinations
// Generate all 60 combinations: index i -> stem = HEAVENLY_STEMS[i%10], branch = EARTHLY_BRANCHES[i%12]
export const SEXAGENARY_CYCLE: readonly string[] = Array.from({length: 60}, (_, i) =>
  `${HEAVENLY_STEMS[i % 10]}${EARTHLY_BRANCHES[i % 12]}`
) as readonly string[];

// 천간 → 오행 매핑
export const STEM_ELEMENT: Record<HeavenlyStem, Ohaeng> = {
  '甲': '木', '乙': '木',
  '丙': '火', '丁': '火',
  '戊': '土', '己': '土',
  '庚': '金', '辛': '金',
  '壬': '水', '癸': '水',
};

// 지지 → 오행 매핑
export const BRANCH_ELEMENT: Record<EarthlyBranch, Ohaeng> = {
  '子': '水', '丑': '土',
  '寅': '木', '卯': '木',
  '辰': '土', '巳': '火',
  '午': '火', '未': '土',
  '申': '金', '酉': '金',
  '戌': '土', '亥': '水',
};

// 오호둔월법 (Five Tiger Escape Month method)
// Maps year stem group to the starting stem index for month 寅 (month 1)
// 甲己 → 丙(2), 乙庚 → 戊(4), 丙辛 → 庚(6), 丁壬 → 壬(8), 戊癸 → 甲(0)
export const MONTH_STEM_START: Record<number, number> = {
  0: 2, // 甲 group (甲己)
  1: 4, // 乙 group (乙庚)
  2: 6, // 丙 group (丙辛)
  3: 8, // 丁 group (丁壬)
  4: 0, // 戊 group (戊癸)
};

// 오자둔시법 (Five Rat Escape Hour method)
// Maps day stem group to the starting stem index for hour 子 (hour 0)
// 甲己 → 甲(0), 乙庚 → 丙(2), 丙辛 → 戊(4), 丁壬 → 庚(6), 戊癸 → 壬(8)
export const HOUR_STEM_START: Record<number, number> = {
  0: 0, // 甲 group (甲己)
  1: 2, // 乙 group (乙庚)
  2: 4, // 丙 group (丙辛)
  3: 6, // 丁 group (丁壬)
  4: 8, // 戊 group (戊癸)
};

// All 24 solar terms with their solar longitudes
export const ALL_SOLAR_TERMS: readonly [string, number][] = [
  ['소한', 285], ['대한', 300], ['입춘', 315], ['우수', 330],
  ['경칩', 345], ['춘분', 0], ['청명', 15], ['곡우', 30],
  ['입하', 45], ['소만', 60], ['망종', 75], ['하지', 90],
  ['소서', 105], ['대서', 120], ['입추', 135], ['처서', 150],
  ['백로', 165], ['추분', 180], ['한로', 195], ['상강', 210],
  ['입동', 225], ['소설', 240], ['대설', 255], ['동지', 270],
] as const;
